import { useCallback, useEffect } from "react";
import { useSetAtom } from "jotai";
import { AipBottomsheet } from "src/website-apps/responsive/stubhub-performer/components/aip-bottomsheet/AipBottomsheet";
import type { AipBottomsheetState } from "src/website-apps/responsive/stubhub-performer/hooks/usePerformerToasts";
import { setBottomSheetOpenAtom } from "src/website-apps/shared/utils/confirmLocationVisibilityAtom";

interface AipBottomsheetFeatureProps {
  state: AipBottomsheetState;
}

export const AipBottomsheetFeature = ({ state }: AipBottomsheetFeatureProps) => {
  const setBottomSheetOpen = useSetAtom(setBottomSheetOpenAtom);
  useEffect(() => {
    setBottomSheetOpen({
      id: "aip-bottomsheet",
      isOpen: state.isOpen,
    });

    return () => {
      setBottomSheetOpen({
        id: "aip-bottomsheet",
        isOpen: false,
      });
    };
  }, [state.isOpen, setBottomSheetOpen]);

  const handleOpenChange = useCallback(
    (open: boolean) => {
      state.onOpenChange(open);
    },
    [state],
  );

  return (
    <AipBottomsheet
      isOpen={state.isOpen}
      onOpenChange={handleOpenChange}
      titleContent={state.titleContent}
      copyVariant={state.copyVariant}
    />
  );
};
